/**
 * 学习中心相关接口
 * 后端模块前缀 /study-*，所有接口 @LoginRequired（token 由请求拦截器自动注入）
 * 统一返回 ResultDto<T>：{ errCode, errMsg, data }，errCode=0 成功
 */

// 专题课程-用户端列表
export const getStudyCourseList = function (params) {
  return this.$http('get', '/study-course/api/list', params)
}

// 专题课程-详情
export const getStudyCourseDetail = function (params) {
  return this.$http('get', '/study-course/admin/detail', params)
}

// 课程视频-用户端列表（按课程）
export const getStudyVideoList = function (params) {
  return this.$http('get', '/study-course-video/api/list', params)
}

// 课程考试题库（按课程，pageSize 取大值拿全量）
export const getStudyExamQuestions = function (params) {
  return this.$http('get', '/study-exam-question/admin/page', params)
}

// 用户维度-考试通过状态（按课程，全部课程）
export const getStudyUserPassStatus = function (params) {
  return this.$http('get', '/study-user-exam/admin/userPassStatus', params)
}

// 答题详情（单次记录）
export const getStudyExamRecordDetail = function (params) {
  return this.$http('get', '/study-user-exam/admin/detail', params)
}

// 用户维度-全部答题记录及明细（按提交时间倒序）
export const getStudyUserAllRecords = function (params) {
  return this.$http('get', '/study-user-exam/admin/userAllRecords', params)
}

// 用户端-提交考试
export const submitStudyExam = function (params) {
  return this.$http('post', '/study-user-exam/api/submit', params)
}

// 用户端-我的考试记录（分页）
export const getMyStudyExamRecords = function (params) {
  return this.$http('get', '/study-user-exam/api/myRecords', params)
}

// 课程维度-用户观看学习状态（前端按 accountId 过滤出当前用户行）
export const getStudyCourseSummary = function (params) {
  return this.$http('get', '/study-user-watch/admin/courseSummary', params)
}

// 用户观看视频记录分页（按 accountId + courseId 过滤当前用户的已看视频）
export const getStudyWatchPage = function (params) {
  return this.$http('get', '/study-user-watch/admin/page', params)
}

// 用户端-观看完成回写
export const recordStudyWatch = function (params) {
  return this.$http('post', '/study-user-watch/api/record', params)
}
